import { SettingsItems } from '@connect-x-app/shared-domain-models';
import { API_FACTORY, sortPushNotificationSettings } from '@connect-x-app/shared-utils';

import { HttpClient } from '../utils/http';

// The body holds only what the API takes: the time zone (the theme stays on the device) and each setting's key and
// state, without the `isUpdating` flag the store keeps while a save is in flight.
export const updateSettings = ({ preferences, pushNotifications }: SettingsItems): Promise<SettingsItems> =>
  HttpClient.put<SettingsItems>(API_FACTORY.v2('settings'), {
    preferences: { timeZone: preferences.timeZone },
    pushNotifications: pushNotifications.map(({ isEnabled, key }) => ({ isEnabled, key })),
  });

export const fetchSettings = async (): Promise<SettingsItems> => {
  const { pushNotifications, ...settings } = await HttpClient.get<SettingsItems>(API_FACTORY.v2('settings'));
  return {
    ...settings,
    pushNotifications: sortPushNotificationSettings(pushNotifications),
  };
};
